import {Typography} from '@mui/material';
import ListSubheader from '@mui/material/ListSubheader';
import {IoChevronBackCircleOutline} from 'react-icons/io5';

const ListSubheaderComponent = (props: any) => {
  return (
    <ListSubheader
      disableGutters
      disableSticky
      onClick={props?.onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        color: 'text.disabled',
        marginTop: '1rem',
        marginBottom: '20px',
        transition: theme1 =>
          theme1.transitions.create(['color'], {
            duration: theme1.transitions.duration.shortest
          }),
        '&:hover': {
          color: 'black'
        },
        width: 'fit-content'
      }}>
      <IoChevronBackCircleOutline size={22} />
      <Typography ml={1} style={{fontSize: 14, fontWeight: 'bold'}}>
        {props?.label}
      </Typography>
    </ListSubheader>
  );
};

export default ListSubheaderComponent;
